"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/parse-int"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Select = _interopRequireDefault(require("../Select/Select"));

var TabNavigation =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(TabNavigation, _PureComponent);

  function TabNavigation(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TabNavigation);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TabNavigation).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_onSelectChange", function (_ref) {
      var value = _ref.value;

      _this.props.onTabClick((0, _parseInt2.default)(value, 10));
    });
    _this._selectItems = (0, _map.default)(_react.Children).call(_react.Children, props.children, function (tab, i) {
      if (tab) {
        return {
          label: tab.props.label,
          value: i.toString()
        };
      }
    });
    return _this;
  }

  (0, _createClass2.default)(TabNavigation, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          selectedIndex = _this$props.selectedIndex,
          onTabClick = _this$props.onTabClick;
      var classes = (0, _classnames.default)('TabNavigation', className);
      return _react.default.createElement("nav", {
        className: classes,
        role: "tablist"
      }, _react.default.createElement("div", {
        className: "TabNavigation-links"
      }, (0, _map.default)(_react.Children).call(_react.Children, children, function (tab, i) {
        if (tab) {
          return (0, _react.cloneElement)(tab, {
            active: selectedIndex === i,
            index: i,
            onTabClick: onTabClick
          });
        }
      })), _react.default.createElement(_Select.default, {
        key: new Date(),
        className: "TabNavigation-select",
        defaultValue: selectedIndex.toString(),
        items: this._selectItems,
        onChange: this._onSelectChange
      }));
    }
  }]);
  return TabNavigation;
}(_react.PureComponent);

exports.default = TabNavigation;